import { Badge } from '@cmpsr/components';
import { PropsWithChildren } from 'react';

export type RiskAssessmentStatusBadgeStatus = 'complete' | 'inaccurate';

type RiskAssessmentStatusBadgeProps = PropsWithChildren & {
  status: RiskAssessmentStatusBadgeStatus;
};

function getRiskAssessmentStatusBadgeStyles(status: RiskAssessmentStatusBadgeStatus) {
  switch (status) {
    case 'complete':
      return {
        color: 'text-success',
        backgroundColor: 'alert-success-default',
      };
    case 'inaccurate':
      return {
        color: 'text-warning',
        backgroundColor: 'alert-warning-default',
      };
  }
}

export default function RiskAssessmentStatusBadge({ status, children }: RiskAssessmentStatusBadgeProps) {
  return (
    <Badge {...getRiskAssessmentStatusBadgeStyles(status)} textTransform="lowercase">
      {children}
    </Badge>
  );
}
